<template>
	<modal-box @close="close" :header="params.action + ' Zone'" subHeader="Geofencing" class="geo-fencing-zone-form">
		<form @submit.prevent="validateAndSubmit">
			<div class="form-row">
				<input-text ref="refName" v-model="model.name" name="zone_name" placeholder="Name" rules="required"/>
				<div class="form-group search">
					<div class="input-wrapper">
						<input id="pac-input" type="text" placeholder="Search location" class="form-control form-control-simple">
						<svgicon name="search" :fill="false"/>
					</div>
				</div>
			</div>
			<div :id="mapName" class="google-map"></div>
			<error-box v-if="form.error" :error="form.error"/>
			<div class="form-group-actions">
				<button-submit-icon-text :loading="form.loading" icon="save">{{ $t('buttons.general.save') }}</button-submit-icon-text>
			</div>
		</form>
	</modal-box>
</template>

<script>
import GoogleMapsLoader from 'google-maps'
export default {
	props: [
		'user_uid',
		'watch_id',
		'params'
	],
	data () {
		return {
			mapName: 'geofencing-map',
			map: null,
			model: {
				name: '',
				positions: []
			},
			form: {
				loading: false,
				error: ''
			},
			drawingManager: null,
			overlays: []
		}
	},
	methods: {
		validateAndSubmit () {
			if (this.model.name.trim() === '') {
				this.$refs.refName.$el.focus()
				return
			}
			if (this.model.positions.length === 0) {
				return
			}
			this.$validator.validateAll()
				.then(result => {
					if (result) this.submit()
				})
		},
		submit () {
			switch (this.params.action) {
				case 'add':
					this.addZone()
					break
				case 'edit':
					this.editZone()
					break
				default:
					this.$log.warn('watch geofencing zone form', 'action not set')()
			}
		},
		close (reload = false) {
			this.$emit('close', { reload })
		},
		getZone () {
			this.model.loading = true
			this.$api.geofencing.get(this, this.user_uid, this.watch_id, this.params.id)
				.then(response => {
					this.$log.info('watch geofencing zone form', 'geofencing.get OK', response)()
					this.model = response.body
					this.setupZone(this.model)
					this.setZone(this.model)
				}).catch(error => {
					this.$log.error('watch geofencing zone form', 'geofencing.get ERROR', error)()
				}).finally(() => {
					this.model.loading = false
				})
		},
		addZone () {
			this.form.loading = true
			this.$api.geofencing.add(this, this.user_uid, this.watch_id, this.model)
				.then(response => {
					this.$log.info('watch geofencing zone form', 'geofencing.add OK', response)()
					this.close(true)
				}).catch(error => {
					this.$log.error('watch geofencing zone form', 'geofencing.add ERROR', error)()
				})
		},
		editZone () {
			var temp = {
				id: this.model.id,
				name: this.model.name,
				positions: []
			}
			var vertices = this.model.polygon.getPath()
			for (var i = 0; i < vertices.getLength(); i++) {
				var xy = vertices.getAt(i)
				temp.positions.push({
					latitude: xy.lat(),
					longitude: xy.lng()
				})
			}
			this.$api.geofencing.edit(this, this.user_uid, this.watch_id, temp)
				.then(response => {
					this.$log.info('watch geofencing zone form', 'geofencing.edit OK', response)()
					this.close(true)
				}).catch(error => {
					this.$log.error('watch geofencing zone form', 'geofencing.edit ERROR', error)()
				})
		},
		setupZone (zone) {
			zone.vertices = zone.positions.map(p => { return { lat: parseFloat(p.latitude), lng: parseFloat(p.longitude) } })
			zone.polygon = new google.maps.Polygon({
				paths: zone.vertices,
				strokeColor: '#ad1375',
				strokeOpacity: 1,
				strokeWeight: 4,
				fillColor: '#eac3dc',
				fillOpacity: 0.35,
				editable: true
			})
			zone.bounds = new google.maps.LatLngBounds()
			zone.vertices.forEach(vertice => {
				const position = new google.maps.LatLng(vertice.lat, vertice.lng)
				zone.bounds.extend(position)
			})
		},
		setZone (zone) {
			zone.polygon.setMap(this.map)
			this.map.fitBounds(zone.bounds)
		},
		setupMap () {
			const element = document.getElementById(this.mapName)
			const options = {
				zoom: 5,
				center: new google.maps.LatLng(0, 0),
				//mapTypeControl: false,
				scaleControl: false,
				streetViewControl: false,
				rotateControl: false,
				fullscreenControl: false
			}

			this.map = new google.maps.Map(element, options)

			let input = document.getElementById('pac-input')
			let searchBox = new google.maps.places.SearchBox(input)

			this.map.addListener('bounds_changed', () => {
				searchBox.setBounds(this.map.getBounds())
			})

			let markers = []

			searchBox.addListener('places_changed', () => {
				let places = searchBox.getPlaces()
				if (places.length == 0) {
					return
				}
				markers.forEach(marker => marker.setMap(null))
				markers = []
				let bounds = new google.maps.LatLngBounds()
				places.forEach(place => {
					if (!place.geometry) {
						console.log('Returned place contains no geometry')
					}
					let icon = {
						url: place.icon,
						size: new google.maps.Size(71, 71),
						origin: new google.maps.Point(0, 0),
						anchor: new google.maps.Point(17, 34),
						scaledSize: new google.maps.Size(25, 25)
					}
					markers.push(new google.maps.Marker({
						map: this.map,
						icon: icon,
						title: place.name,
						position: place.geometry.location
					}))
					if (place.geometry.viewport) {
						bounds.union(place.geometry.viewport)
					} else {
						bounds.extend(place.geometry.location)
					}
				})
				this.map.fitBounds(bounds)
			})

			this.drawingManager = new google.maps.drawing.DrawingManager({
				drawingMode: google.maps.drawing.OverlayType.POLYGON,
				drawingControl: true,
				drawingControlOptions: {
					position: google.maps.ControlPosition.LEFT_CENTER,
					drawingModes: ['polygon']
				},
				polygonOptions: {
					strokeColor: '#ad1375',
					strokeOpacity: 1,
					strokeWeight: 2,
					fillColor: '#eac3dc',
					fillOpacity: 0.35
				}
			})
			this.drawingManager.setMap(this.map)
			google.maps.event.addListener(this.drawingManager, 'overlaycomplete', this.onOverlayComplete)

			this.map.addListener('click', this.removeShapes);
		},
		onOverlayComplete (event) {
			if (event.type === 'polygon') {
				this.model.positions = []
				let overlay = event.overlay
				let vertices = overlay.getPath()
				for (var i = 0; i < vertices.getLength(); i++) {
					let xy = vertices.getAt(i)
					this.model.positions.push({
						latitude: xy.lat(),
						longitude: xy.lng()
					})
				}
				this.overlays.push(overlay)

				google.maps.event.addListener(overlay, 'click', this.removeShapes)
				this.drawingManager.setDrawingMode(null);
			}
		},
		removeShapes () {
			this.overlays.map(e => e.setMap(null));
			this.overlays = []
			this.model.positions = []
			this.drawingManager.setDrawingMode('polygon');
		},
		geoLocation () {
			if (navigator.geolocation)
				navigator.geolocation.getCurrentPosition(this.setCenter)
		},
		setCenter (position) {
			this.map.setCenter(new google.maps.LatLng(position.coords.latitude, position.coords.longitude))
			this.map.setZoom(10)
		}
	},
	mounted () {
		GoogleMapsLoader.KEY = this.$root.settings.googleMapsKey
		GoogleMapsLoader.LIBRARIES = this.$root.settings.googleMapsLibraries
		GoogleMapsLoader.load(() => {
			this.setupMap()
			if (this.params.action === 'edit') {
				if (this.data === undefined) {
					this.getZone()
				} else {
					this.model = this.data
					this.setupZone(this.model)
					this.setZone(this.model)
				}
			}
			if (this.params.action === 'add') {
				this.geoLocation()
			}
		})
	},
	destroyed () {
		// Clean up google places leftovers
		let elements = document.getElementsByClassName('pac-container pac-logo')
		for (let i = 0; i < elements.length; i++) {
			elements[i].parentNode.removeChild(elements[i])
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/readings/geofencing/ZoneForm.vue